export default "__VITE_ASSET__CjQaq_iv__"